import OpenDataMapper from '../../../../components/Mappers/OpenDataMapper'
import { OpenDataIndicator } from '../../../../interfaces/OpenData'
import CustomCheckbox from '../../../../components/Inputs/Checkbox/CustomCheckbox';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { clearSelections, selectAllIndicators } from '../../../../redux/slices/openData/openDataFiltersSlice';
import ButtonDropdown from '../../../../components/Dropdown/ButtonDropdown';
import { MdArrowDropDown, MdInfo, MdOutlineInfo } from 'react-icons/md';
import { downloadIndicatorCSV, downloadIndicatorClusteredBase, downloadIndicatorMetadataBase } from '../../utils/downloads';
import { Period } from '../../../../interfaces/Periods';
import { getAllIndicatorsForDownload } from '../../../../redux/slices/openData/openDataThunk';
import Loading from '../../../../components/Loading/Loading';
import { getIdsFromTitles } from '../../utils/getIdsFromTitles';
import { useState } from 'react';
import Dialog from '../../../../components/Dialog/Dialog';
import Button from '../../../../components/Buttons/Button';
interface OpenDataIndicatorsProps {
    indicators: OpenDataIndicator[];
}

const getDropdownOptions = (selectedIndicators: OpenDataIndicator[], periods: Period[]) => [
    {
        label: 'Bases individuales (csv)',
        action: () => downloadIndicatorCSV({ indicators: selectedIndicators, format: 'csv' })
    },
    {
        label: 'Bases individuales (excel)',
        action: () => downloadIndicatorCSV({ indicators: selectedIndicators, format: 'excel' })
    },
    {
        label: 'Base agrupada (csv)',
        action: () => downloadIndicatorClusteredBase({ indicators: selectedIndicators, periods: periods, format: 'csv' })
    },
    {
        label: 'Base agrupada (excel)',
        action: () => downloadIndicatorClusteredBase({ indicators: selectedIndicators, periods: periods, format: 'excel' })
    },
    {
        label: 'Base de metadatos (csv)',
        action: () => downloadIndicatorMetadataBase({ indicators: selectedIndicators, periods: periods, format: 'csv' })
    },
    {
        label: 'Base de metadatos (excel)',
        action: () => downloadIndicatorMetadataBase({ indicators: selectedIndicators, periods: periods, format: 'excel' })
    }
];

const OpenDataIndicators = ({ indicators }: OpenDataIndicatorsProps) => {
    const dispatch = useAppDispatch();

    const [isModalVisible, setIsModalVisible] = useState(false);

    const selectedIndicators = useAppSelector((state) => state.open_data_filters.selectedIndicators);
    const periods = useAppSelector((state) => state.periods.periods);
    const filters = useAppSelector((state) => state.open_data_filters);
    const totalItems = useAppSelector((state) => state.open_data.pagination.totalItems);
    const isLoadingAllIndicators = useAppSelector((state) => state.open_data_filters.isLoadingAllIndicators);
    const allIndicatorsCache = useAppSelector((state) => state.open_data_filters.allIndicatorsCache);
    const isAllSelected = useAppSelector((state) => state.open_data_filters.isAllSelected);

    const allSelected = isAllSelected || (selectedIndicators.length === totalItems && totalItems > 0);

    const handleSelectAll = () => {
        if (allSelected) {
            dispatch(clearSelections());
        } else {
            if (indicators.length === totalItems) {
                dispatch(selectAllIndicators(indicators));
            } else {
                if (allIndicatorsCache && allIndicatorsCache.length > 0) {
                    dispatch(selectAllIndicators(allIndicatorsCache));
                } else {
                    const odsIds = getIdsFromTitles(filters, filters.ods, 'ods');
                    const priorityGroupsIds = getIdsFromTitles(filters, filters.priorityGroups, 'gruposPrioritarios');

                    dispatch(getAllIndicatorsForDownload({
                        typeIndicator: filters.tiposIndicadores.length > 0 ? filters.tiposIndicadores : undefined,
                        dimensiones: filters.dimensiones.length > 0 ? filters.dimensiones : undefined,
                        derechos: filters.derechos.length > 0 ? filters.derechos : undefined,
                        gruposPrioritarios: priorityGroupsIds.length > 0 ? priorityGroupsIds : undefined,
                        ods: odsIds.length > 0 ? odsIds : undefined,
                        variables: filters.variables.length > 0 ? filters.variables : undefined,
                    }));
                }
            }
        }
    };

    const optionsDropdown = getDropdownOptions(selectedIndicators, periods ?? []);

    return (
        <>
            <div className='flex justify-between mr-4'>
                <div className='flex items-center gap-2'>
                    <ButtonDropdown
                        label={`Descargar seleccionados (${selectedIndicators.length})`}
                        options={optionsDropdown}
                        icon={MdArrowDropDown}
                        className='!px-4 border rounded-md bg-primary-100 border-brand-orange-20/80'
                        disabled={!selectedIndicators.length}
                        variant='outline-orange'
                    />
                    <Button
                        onClick={() => setIsModalVisible(!isModalVisible)}
                        className='text-brand-green-30 !px-0 !rounded-full !h-fit'
                        icon={MdOutlineInfo}
                        iconSize={24}
                        label=''
                        showIconLeft={false}
                        showIconRight={true}
                        variant='ghost'
                    />
                </div>
                <div className='flex items-center gap-2'>
                    {isLoadingAllIndicators && (
                        <Loading size={24} color="#DF6B4E" />
                    )}
                    <CustomCheckbox
                        label=''
                        id={'select-all-indicators'}
                        checked={allSelected}
                        onChange={handleSelectAll}
                        name='global'
                        disabled={isLoadingAllIndicators}
                    />
                </div>
            </div >
            <OpenDataMapper
                indicators={indicators}
            />
            <Dialog isOpen={isModalVisible} toggle={() => setIsModalVisible(false)} bgColor='bg-brand-green-5'>
                <div className="flex justify-center mb-2 gap-2">
                    <MdInfo size={32} color="#205253" />
                    <h2 className="text-center text-hsmall text-system-light-100 mb-4">
                        Información
                    </h2>
                </div>
                <p className="text-left text-bmedium text-system-light-40">
                    Debido a limitaciones de Excel, este archivo puede no visualizarse correctamente en formato .csv. Se recomienda descargarlo en formato Excel o abrir el .csv con un editor de texto.
                </p>
            </Dialog>
        </>
    )
}

export default OpenDataIndicators